import React from 'react';
import { IMaskInput } from 'react-imask';
import { InputBaseComponentProps } from '@mui/material';
import { MaskedInputType, TypeToMaskMapping } from './masked-input.types';
import { useField } from 'formik';

export type MaskedInputComponentProps = InputBaseComponentProps & {
  mask?: string;
  type?: MaskedInputType;
  showPlaceholder?: boolean;
  placeholderChar?: string;
};


export const MaskedInputComponent: React.VFC<MaskedInputComponentProps> = (props) => {
  const [ _field, _meta, { setValue } ] = useField(props.name);
  const { inputRef, onChange, showPlaceholder = true, placeholderChar = ' ', ...other } = props;
  const _mask = (other.type && TypeToMaskMapping[other.type]) || other.mask;

  const handleAccept = React.useCallback((value: unknown) => {
    setValue(value);
  }, [ setValue ]);

  if (_mask) {
    return (
      <IMaskInput
        {...other}
        inputRef={inputRef}
        onAccept={handleAccept}
        mask={_mask}
        lazy
        placeholderChar={placeholderChar}
        placeholder={showPlaceholder ? _mask.replace(/0/g, ' ') : other.placeholder}
      />
    );
  }

  return (
    <input
      {...other}
      ref={inputRef}
      onChange={onChange}
    />
  );
};
